const RETRYABLE_CODES = new Set([
  'functions/deadline-exceeded',
  'functions/unavailable',
  'functions/internal',
  'deadline-exceeded',
  'unavailable',
  'internal',
]);

export function isRetryableCallableError(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false;
  const code = 'code' in err ? String((err as { code: unknown }).code) : '';
  const message = 'message' in err ? String((err as { message: unknown }).message) : '';
  if (RETRYABLE_CODES.has(code)) return true;
  return /deadline-exceeded|UNAVAILABLE/i.test(`${code} ${message}`);
}

/** One retry after a short wait — covers a callable that timed out while a cold instance was still starting. */
export async function callWithRetry<T>(fn: () => Promise<T>, delayMs = 1500): Promise<T> {
  try {
    return await fn();
  } catch (err) {
    if (!isRetryableCallableError(err)) throw err;
    await new Promise(resolve => setTimeout(resolve, delayMs));
    return fn();
  }
}
